import type { ICache } from '../interface/cache';

function Cache(): ICache {
    const store: Record<string | number | symbol, unknown> = {};

    return {
        add: (key: string | number | symbol, value: unknown): void => {
            store[key] = value;
        },
        get: (key: string | number | symbol) => store[key],
    };
}

export default Cache;
